var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parter-logo"},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"parter-img",attrs:{"src":item.url}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }